import gsap from 'gsap'
import { each } from 'lodash'
import { app, menu } from '../../utils/store'
import { activate, deactivate, available, disable } from '../../utils/states'
import { media } from '../../utils/media'

export default class Products {
    constructor() {
        this.main = {
            toggler: document.getElementById('menu-toggler'),
            menu: document.getElementById('main-menu'),
            account: document.querySelector('[data-menu-account]'),

        }
        this.products = {
            toggler: document.querySelectorAll('[data-target="products-menu"]'),
            menu: document.getElementById('products-menu'),
            nav: document.querySelector('#products-menu [data-menu-products]'),
            list: document.querySelector('#products-menu [data-list-products]'),
            buttons: document.querySelectorAll('#products-menu li a'),
        }

        this.rooms = {
            toggler: document.querySelectorAll('[data-target="rooms-menu"]')
        }
        this.configurator = {
            toggler: document.querySelectorAll('[data-target="configurator-modal"]')
        }
        this.store = {
            toggler: document.querySelectorAll('[data-target="store"]')
        }

        this.space = {
            toggler: document.querySelectorAll('[data-target="space"]')
        }

        this.contract = {
            toggler: document.querySelectorAll('[data-target="contract"]')
        }


        this.current = {}

        this.toggle()

        // each(this.products.buttons, (button) => {
        //     button.onmouseover = this.onMouseHover
        // })
    }

    toggle = () => {
        each(this.products.toggler, (toggler) => {
            toggler.onclick = () => {
                // var container = document.createElement('div')
                // //CONTAINER
                // container.classList.add('col-12')
                // container.classList.add('col-md-6')
                // container.setAttribute('data-preview-products', '')

                // this.products.list.append(container)

                if ((!menu.isOpen && menu.current != 'products') || (menu.isOpen && menu.current == 'main')) { // if this.isMenuOpen = false
                    this.open()
                    menu.current = 'products'
                    menu.isOpen = true

                    if (!media('>=iPadLandscape')) {
                        this.main.toggler.classList.add('back')
                        menu.isBack = true
                    }
                }
                else { // if menu.isOpen = true
                    this.close()
                    menu.current = undefined
                    menu.isOpen = false
                }
                console.log(menu)

            }
        })
    }

    open = () => {
        // Check states in utils folder for understand
        activate(this.main.toggler)
        activate(this.products.menu)
        if (media('>=iPadLandscape')) {
            // each(this.products.toggler, (toggler) => activate(toggler))
            // each(this.rooms.toggler, (toggler) => disable(toggler))
            // each(this.store.toggler, (toggler) => disable(toggler))
            // each(this.configurator.toggler, (toggler) => disable(toggler))
            // each(this.space.toggler, (toggler) => disable(toggler))
            // each(this.contract.toggler, (toggler) => disable(toggler))
        }
        document.body.classList.add('navigation-products--open')
    }

    close = () => {
        deactivate(this.main.toggler)
        deactivate(this.products.menu)
        if (media('>=iPadLandscape')) {
            // each(this.products.toggler, (toggler) => deactivate(toggler))
            // each(this.rooms.toggler, (toggler) => available(toggler))
            // each(this.store.toggler, (toggler) => available(toggler))
            // each(this.configurator.toggler, (toggler) => available(toggler))
            // each(this.space.toggler, (toggler) => available(toggler))
            // each(this.contract.toggler, (toggler) => available(toggler))
        }
        document.body.classList.remove('navigation-products--open')
    }
}
